import script from "./Galery.vue?vue&type=script&setup=true&lang=ts"
export * from "./Galery.vue?vue&type=script&setup=true&lang=ts"

import "./Galery.vue?vue&type=style&index=0&id=0161f38a&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0161f38a"]])

export default __exports__